import React from 'react';
import ReactDOM from 'react-dom/client';
import reactAxe from '@axe-core/react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import worker from './mocks/browser';
import { ENVIRONMENT_KEY } from './localStorageKeys';
import { mockSessionCookie } from './utils/mockCookie';

async function prepareMockServiceWorker(): Promise<void> {
  if (process.env.REACT_APP_MSW_ENABLED !== 'true') return;
  mockSessionCookie();
  await worker.start();
}

if (process.env.REACT_APP_AXE_ENABLED === 'true') {
  reactAxe(React, ReactDOM, 1000);
}

if (
  process.env.REACT_APP_SENTRY_ENABLED === 'true' &&
  localStorage.getItem(ENVIRONMENT_KEY) !== 'localhost'
) {
  Sentry.init({
    environment: localStorage.getItem(ENVIRONMENT_KEY)!,
    dsn: 'todo', // change it
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: 1.0,
    autoSessionTracking: true,
    profilesSampleRate: 0.25,
    release: `booking-ui@${process.env.REACT_APP_BUILD_VERSION}`,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

void prepareMockServiceWorker()
  .catch((err) => {
    console.error('[MSW] Failed to start mock service worker:', err);
  })
  .finally(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
    reportWebVitals();
  });
